// Global CSS-in-JS styles injected at the app level.
// Mantine v7 removed the <Global> component — we inject a <style> tag directly.
export const GlobalStyles = () => (
  <style>{`
    /* ── Mobile nav tap highlight fix ────────────────────────────────────── */
    /* Mantine scopes the NavLink :active state to @media (hover: none), which
       is exactly touch devices. This override runs after the static CSS file
       so it wins the cascade at equal specificity. */
    @media (hover: none) {
      .mantine-NavLink-root:active {
        background-color: color-mix(in srgb, white 20%, transparent);
        color: white;
      }
    }

    /* ── Blog / news article content ─────────────────────────────────────── */
    .style-content-blog,
    .style-content-blog * {
      /* Use the exact app font stack (Mantine derives this from theme.fontFamily)
         so CMS-provided text matches the rest of the UI on every platform — a bare
         'Segoe UI' fell back to a different generic font on macOS. !important also
         overrides any inline font the CMS ships. */
      font-family: var(--mantine-font-family) !important;
      color: #364152;
    }

    .style-content-blog h1 {
       font-size: 36px;
      font-weight: 300;
      line-height: 46px;
      color: #364152;
      scroll-margin-top: 120px;
    }

    @media screen and (min-width: 820px) {
      .style-content-blog h1 {
        font-size: 72px;
        font-weight: 200;
        line-height: 88px;
      }
    }

    .style-content-blog h2 {
      margin-block: 16px;
      font-weight: 400;
      font-size: 32px;
      line-height: 1.3;
      color: #364152;
      scroll-margin-top: 70px;
    }

    @media screen and (min-width: 820px) {
      .style-content-blog h2 {
        font-size: 40px;
        font-weight: 400;
        line-height: 1.3;
      }
    }

    .style-content-blog h3 {
      margin-block: 16px;
      font-weight: 400;
      font-size: 26px;
      line-height: 1.3;
      color: #364152;
      scroll-margin-top: 70px;
    }

    @media screen and (min-width: 820px) {
      .style-content-blog h3 {
        font-weight: 400;
        font-size: 30px;
        line-height: 1.3;
      }
    }

    .style-content-blog h4 {
      margin-block: 8px;
      font-weight: 400;
      font-size: 20px;
      line-height: 1.3;
      color: #364152;
      scroll-margin-top: 70px;
    }

    @media screen and (min-width: 820px) {
      .style-content-blog h4 {
        font-weight: 400;
        font-size: 24px;
        line-height: 41px;
      }
    }

    .style-content-blog h5 {
      margin-block: 16px;
      font-weight: 300;
      line-height: 28px;
      font-size: 16px;
      color: #364152;
      scroll-margin-top: 70px;
    }

    @media screen and (min-width: 820px) {
      .style-content-blog h5 {
        font-size: 24px;
      }
    }

    .style-content-blog h6 {
      margin-block: 16px;
      font-weight: 300;
      font-size: 16px;
      line-height: 26px;
      color: #364152;
      scroll-margin-top: 70px;
    }

    @media screen and (min-width: 820px) {
      .style-content-blog h6 {
        font-size: 22px;
      }
    }

    .style-content-blog p {
      font-weight: 400;
      font-size: 16px;
      line-height: 1.7;
      color: #364152;
    }

    .style-content-blog hr {
      border: 0;
      background-color: #364152;
      height: 1px;
    }

    .style-content-blog ul {
      display: block;
      list-style-type: disc;
      margin-block-start: 1em;
      margin-block-end: 1em;
      margin-inline-start: 0px;
      margin-inline-end: 0px;
      padding-inline-start: 40px;
      color: #364152;
      font-weight: 400;
    }

    .style-content-blog ol {
      display: block;
      list-style-type: decimal;
      margin-block-start: 1em;
      margin-block-end: 1em;
      margin-inline-start: 0px;
      margin-inline-end: 0px;
      padding-inline-start: 40px;
      color: #364152;
      font-weight: 400;
    }

    .style-content-blog li[data-list="bullet"] {
      list-style-type: disc;
    }

    .style-content-blog li[data-list="ordered"] {
      list-style-type: decimal;
    }

    .style-content-blog a,
    .style-content-blog a * {
      color: var(--mantine-color-success-5) !important;
    }

    .style-content-blog blockquote {
      padding: 15px;
      background: #eee;
      color: #364152;
      font-size: 16px;
      border-radius: 12px;
      margin-block: 20px;
    }

    .style-content-blog blockquote p::before {
      content: "\u201c";
    }

    .style-content-blog blockquote p::after {
      content: "\u201d";
    }

    .style-content-blog table {
      max-width: 100%;
    }

    .style-content-blog table tr td,
    .style-content-blog table tr th {
      padding: 14px;
      border: 1px solid #364152;
    }

    .style-content-blog table tr td {
      color: var(--mantine-color-primary-7);
    }

    .style-content-blog table tr th {
      background-color: var(--mantine-color-primary-6);
      color: white;
    }

    .style-content-blog video,
    .style-content-blog iframe,
    .style-content-blog img {
      display: inline-block;
    }

    .style-content-blog .ql-video {
      width: 100%;
      height: 400px;
      opacity: 0.99;
    }

    @media screen and (max-width: 820px) {
      .style-content-blog .ql-video {
        height: 240px;
      }
    }

    .style-content-blog img {
      max-width: 100%;
      vertical-align: middle;
      height: auto !important;
      border-top: 1px solid #dbe4ef;
      border-bottom: 1px solid #dbe4ef;
      margin-block: 20px;
    }

    .style-content-blog > p:first-of-type::first-letter {
      -webkit-initial-letter: 2;
      initial-letter: 2;
      display: block;
      margin-right: 10px;
    }

    /* ── Scroll anchor offsets ────────────────────────────────────────────── */
    #overview {
      scroll-margin-top: 120px;
    }

    /* ── Blog page wrapper ────────────────────────────────────────────────── */
    .blog-page {
      background-color: white;
    }

    /* ── Table of contents active indicator ──────────────────────────────── */
    .toc-indicator {
      position: absolute;
      left: -2px;
      top: 0;
      bottom: 0;
      width: 2px;
      background: var(--mantine-color-blue-5);
    }

    .style-benefit, .style-benefit p, .style-benefit span {
      color: var(--mantine-color-dimmed) !important;
      font-size: 14px !important;
    }

      .style-benefit ul {
        margin: 8px 0;
        padding-left: 20px;
      }

      .style-benefit li {
        margin-bottom: 4px;
      }

    .benefit-scroll::-webkit-scrollbar {
      width: 4px;
    }
    .benefit-scroll::-webkit-scrollbar-track {
      background: transparent;
    }
    .benefit-scroll::-webkit-scrollbar-thumb {
      background: var(--mantine-color-gray-3);
      border-radius: 4px;
    }
    .benefit-scroll::-webkit-scrollbar-thumb:hover {
      background: var(--mantine-color-gray-5);
    }

    /* ── Navigation progress bar ──────────────────────────────────────────── */
    @keyframes nav-progress-slide {
      0%   { transform: translateX(-100%); }
      100% { transform: translateX(500%); }
    }

  `}</style>
)
